export default __webpack_public_path__ + "static/blob7-40fccd3496fd6d397a144fc5ac554a8d.svg";